<template>
  <div class="container">
      <!-- 公共头部 -->
      <div class="fixedTop">
          <div class="content">
              <div class="left">
				  <!-- 越易蓝logo -->
               <img class="logo" src="https://www.yueyilan.com/img-yueyilan/upload/photo/yyl/logo.png" alt="图片">
                <img class="font" src="https://www.yueyilan.com/img-yueyilan/upload/photo/logo/logo2.png" alt="图片">
				<!-- 在水一方logo -->
				 <!-- <img class="logo" src="../assets/logo.png" alt="图片">
				 <img class="font" src="../assets/text.png" alt="图片"> -->
            </div>
            <!-- 网页端 -->
            <div class="banner web">
                <ul class="list">
                    <li class="one" v-for="(item,index) in bannerLink" :key="item.title" @mouseenter="hoverHeight(1,index)" @mouseleave="hoverHeight(0,index)">
                        <router-link tag="p" :class="['link',item.component===$route.name?'active':'']" :to="{name:item.component,params:{type:1}}">{{item.title}}</router-link>
                        <div class="line"></div>
                        <ul class="two" :style="{height:item.height+'px'}">
                            <li class="leveltwo" v-for="el in item.list" :key="el.title"><router-link tag="p" :to="{name:el.component,params:{type:el.type}}">{{el.title}}</router-link></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- 移动端 -->
            <div class="banner phone" :style="{right:bannerRight}">
                <div class="shadow" @click="bannerRight='-100%'"></div>
                <ul class="list">
                    <li class="one" v-for="(item,index) in bannerLink" :key="item.title" @click="changeheight(index)">
                        <p v-if="item.list.length" :class="['link',item.height?'open':'',item.component===$route.name?'active':'']">{{item.title}}</p>
                        <router-link v-else tag="p" :class="['link',item.component===$route.name?'active':'']" :to="{name:item.component,params:{type:1}}">{{item.title}}</router-link>
                        
                        <ul class="two" :style="{height:item.height+'px'}">
                            <li class="leveltwo" v-for="el in item.list" :key="el.title"><router-link tag="p" :to="{name:el.component,params:{type:el.type}}">{{el.title}}</router-link></li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="bannerPhone" id="banner" @click="bannerRight=0">
                <img src="@/assets/nav.png" alt="图片">
            </div>
          </div>
      </div>
      <div class="areaContent">
          <router-view></router-view>
      </div>
      <!-- 公共底部 -->
      <div class="footer">
          <div class="content">
              <div class="link">
                友情链接
                <div class="documentLinkBox">
					<div class="documentLink" v-for="item in friendsLink" :key="item.name">
							<a target="_blank" :href="item.link">{{item.name}}</a>
						</div>
                   <!-- <ul class="documentClose" :style="{height:friendsLinkHeight+'px'}">
                        <li class="documentClose" v-for="item in friendsLink" :key="item.name"><a class="documentClose" target="_blank" :href="item.link">{{item.name}}</a></li>
                    </ul> -->
                    <!-- <div class="documentClose arrow" @click="linkHeight"><img class="documentClose" src="../assets/arrow2.png" alt="下拉"></div> -->
                </div>
            </div>
            <div class="bottom">
                <div class="left">
                    <p>咨询建议电话：86566043</p>
                    <p>邮箱：2554652441@163.com</p>
                    <!-- <p>地址：浙江省 杭州市 上城区 姚江路29号 二楼</p> -->
					<p>地址：浙江省 杭州市 上城区 姚江路39号</p>
                </div>
                <div class="right">
                    <p>服务热线</p>
                    <p class="phone">0571-96033</p>
                </div>
            </div>
          </div>
      </div>
      <div class="beianNumber">
          <p>Copyright © {{date}} - 杭州越易蓝科技有限公司</p>
		  <!-- <a target="_blank" style="color: #999999;" href="https://beian.miit.gov.cn">浙ICP备19013293号</a> -->
		  <a target="_blank" style="color: #999999;" href="https://beian.miit.gov.cn">浙ICP备19013293号-1</a>
          <!-- <p>浙ICP备19013293号-1</p> -->
      </div>
  </div>
</template>

<script>
import link from '@/link.js'
export default {
  name: 'Formal',
  data () {
    return {
      bannerLink:link,
      friendsLink:[
          {
              link:'http://www.daai60.org/',
              name:'浙江大爱老年事务中心'
          },
          {
              link:'https://www.zjlnfw.com/',
              name:'浙江老年服务网'
          },
          {
              link:'http://mz.hangzhou.gov.cn/',
              name:'杭州市民政局'
          }
      ],
      friendsLinkHeight:24,
      bannerRight:'-100%',
	  date:'2020'
    }
  },
  watch:{
      $route(){
          this.bannerRight = '-100%';
      }
  },
  mounted() {
  	this.getYear()
  },
  methods:{
      //导航展开--web
      hoverHeight(type,index){
          if(type){
              this.bannerLink[index].height = 40*this.bannerLink[index].list.length;
          }else{
              this.bannerLink[index].height = 0;
          }
      },
	  getYear(){
		var date = new Date();
		this.date = date.getFullYear(); //获取完整的年份(4位)
	  },
      //导航展开--移动端
      changeheight(index){
          this.bannerLink.forEach(function(ele,el){
              if(index===el){
                  ele.height = 40*ele.list.length;
              }else{
                  ele.height = 0;
              }
          })
      },
      //友情链接展开
      linkHeight(){
          this.friendsLinkHeight = 24*this.friendsLink.length
      },
      //关闭友情链接
      closeThis(e){
          if(e.target.className.indexOf('documentClose')<0){
              this.friendsLinkHeight=24;
          }
      }
  }
}
</script>
<style scoped lang="scss">
    .container{
        width: 100%;
        .fixedTop{
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100px;
            background-color: #fff;
            z-index: 10000;
            .content{
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .left{
                    .logo{
                        width: 62px;
                        margin-right: 16px;
                    }
                    .font{
                        width: 300px;
                    }
                }
                .banner.web{
                    display: flex;
                    align-items: center;
                    .list{
                        display: flex;
                        align-items: flex-start;
                        height: 76px;
                        overflow: visible;
                        .one{
                            font-size: 16px;
                            color: #333;
                            position: relative;
                            line-height: 76px;
                            margin: 0 8px;
                            .link{
                                cursor: pointer;
                                position: relative;
                                padding: 0 16px;
                                &::before{
                                    display: inline-block;
                                    width: 0;
                                    height: 4px;
                                    background-color: #1797E0;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    clear: both;
                                    content: "";
                                    transition: .3s ease-out;
                                }
                            }
                            .link.active,.link.router-link-active{
                                color: #1797E0;
                                &::before{
                                    width: 100%;
                                }
                            }
                            .two{
                                width: 100%;
                                transition: .3s ease-out;
                                text-align: center;
                                overflow: hidden;
                                li{
                                    width: 100%;
                                    height: 40px;
                                    line-height: 40px;
                                    p{
                                        background-color: #1797E0;
                                        transition: .3s ease-out;
                                        color: #fff;
                                        cursor: pointer;
                                    }
                                    p:hover{
                                        background-color: #0C5B8A;
                                    }
                                }

                            }
                        }
                        .one:hover{
                            .link{
                                color: #1797E0;
                                &::before{
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
                .banner.phone{
                    display: none;
                    position: fixed;
                    top: 0;
                    right: -100%;
                    color: #fff;
                    width: 100%;
                    height: 100%;
                    transition: .3s ease-out;
                    justify-content: space-between;
                    .shadow{
                        background-color: rgba(0, 0, 0, 0.5);
                        width: 20px;
                        flex-grow: 1;
                        height: 100%;
                    }
                    ul{
                        display: inline-block;
                        width: 270px;
                        height: 100%;
                        overflow: auto;
                        background-color: rgba(12, 91, 138, 1);
                        text-align: left;
                        flex-shrink: 0;
                        .one{
                            font-size: 0;
                            .link{
                                height: 72px;
                                line-height: 72px;
                                width: 100%;
                                box-sizing: border-box;
                                padding: 0 20px;
                                font-size: 16px;
                            }
                        }
                        .two{
                            background-color: rgba(127, 194, 234, .2);
                            transition: .3s ease-out;
                            li{
                                width: 100%;
                                height: 40px;
                                line-height: 40px;
                                font-size: 14px;
                                p{
                                    box-sizing: border-box;
                                    padding: 0 20px;
                                }
                                &:hover,.router-link-exact-active{
                                    background-color: rgba(127, 194, 234, .6);
                                }
                            }
                        }
                        .link.active{
                            background-color: rgba(127, 194, 234, .6);
                            
                        }
                        .link.open{
                            background-color: rgba(127, 194, 234, .2);
                        }
                    }
                }
                .bannerPhone{
                    display: none;
                }
            }
        }
        .areaContent{
            margin-top: 100px;
            width: 100%;
        }
        .footer{
            width: 100%;
            background-color: #BECCD5;
            .content{
                width: 1200px;
                margin: 0 auto;
                .link{
                    padding: 30px 0 20px;
                    border-bottom: 1px solid #fff;
                    font-size: 22px;
                    color: #fff;
					.documentLinkBox{
						width: 100%;
						display: flex;
						flex-direction: row;
						justify-content: space-around;
						flex-wrap: wrap;
					}
					.documentLink{
						// overflow: visible;
						// display: inline-block;
						// vertical-align: top;
						width: 100%;
						font-size: 16px;
						height: 30px;
						line-height: 44px;
						// margin-left: 36px;
						a{
							color: #2e2e2e;
						}
					}
                    .select{
                        width: 240px;
                        // background-color: #fff;
                        height: 24px;
                        overflow: visible;
                        display: inline-block;
                        vertical-align: top;
                        margin-top: 6px;
                        margin-left: 20px;
                        // position: relative;
                    }
                }
                .bottom{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px 0 30px;
                    .left{
                        font-size: 16px;
                        color: #fff;
                        line-height: 30px;
                    }
                    .right{
                        color: #fff;
                        font-size: 24px;
                        line-height: 24px;
                        .phone{
                            font-size: 36px;
                            line-height: 36px;
                            margin-top: 24px;
                        }
                    }
                }
            }
        }
        .beianNumber{
            text-align: center;
            font-size: 16px;
            color: #909399;
            line-height: 24px;
            padding: 32px 0;
        }
    }
    @media screen and (max-width: 1200px){
        .container .footer .content{
            width: 100%;
            box-sizing: border-box;
            padding: 24px;
            .link{
                font-size: 16px;
                .select{
                    margin-top: 0;
                    width: 180px;
                    margin-left: 12px;
                    ul{
                        li{
                            font-size: 12px;
                        }
                    }
                }
            }
            .bottom{
                .left{
                    font-size: 12px;
                    line-height: 24px;
                }
                .right{
                    font-size: 18px;
                    .phone{
                        font-size: 28px;
                        margin-top: 10px;
                    }
                }
            }
        }
        .container .beianNumber{
            font-size: 12px;
            padding: 20px 0;
        }
        .container .fixedTop .content{
            width: 100%;
            box-sizing: border-box;
            padding: 0 24px;
        }
        .container .fixedTop .content .bannerPhone{
            width: 32px;
            height: 32px;
            cursor: pointer;
            display: block;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .container .fixedTop .content .banner.web{
            display: none;
        }
        .container .fixedTop .content .banner.phone{
            display: flex;
        }
    }
    @media screen and (max-width: 768px){
        .container{
            .fixedTop{
                height: auto;
                padding: 16px 0;
                .content{
                    padding: 0 16px;
                    .left{
                        .logo{
                            width: 40px;
                            margin-right: 8px;
                        }
                        .font{
                            width: 200px;
                        }
                    }
                    .bannerPhone{
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .areaContent{
                margin-top: 56px;
            }
        }
        .container .fixedTop .content .banner.phone ul{
            width: 50%;
            .one{
                .two{
                    width: 100%;
                }
            }
        }
        .container .footer .content{
            padding: 0 16px;
            .bottom{
                display: block;
                text-align: center;
                .right{
                    margin-top: 36px;
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/Formal.vue